/**
 * Optimizaciones de Zone.js para mejorar rendimiento
 * Deshabilita patches innecesarios para reducir overhead
 */
// eslint-disable-next-line no-underscore-dangle
(window as any).__Zone_disable_customElements = true;
// Deshabilitar patches de eventos que no son críticos
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove', 'mouseenter', 'mouseleave'];
// Deshabilitar patch de requestAnimationFrame para mejor rendimiento
(window as any).__Zone_disable_requestAnimationFrame = false; // Mantenerlo para animaciones
